<script setup lang="ts">
import InputText from "primevue/inputtext";
import { useId } from "vue";
</script>

<template>
  <InputText :id="`input-text-${useId()}`" v-bind="$attrs" />
</template>

<style lang="postcss" scoped></style>
